import { useEffect } from "react";

/**
 * Injecte et nettoie le script Google Tag (gtag.js) dans le <head>.
 * @param {string} tagId - L'identifiant Google Tag (ex: 'AW-948325592')
 */
export function useGoogleTag(tagId) {
  useEffect(() => {
    if (!tagId) return;

    // Injecter le script externe
    const scriptTag = document.createElement("script");
    scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
    scriptTag.async = true;
    document.head.appendChild(scriptTag);

    // Injecter le script inline
    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${tagId}');
    `;
    document.head.appendChild(inlineScript);

    // Nettoyage lors du démontage
    return () => {
      document.head.removeChild(scriptTag);
      document.head.removeChild(inlineScript);
    };
  }, [tagId]);
}